import React, { Component } from 'react';
import Dashboard from './components/dashboard';
import './styles/App.css';

class App extends Component {
  render() {
    return (
    	<div className="App">
			<Dashboard />
	    </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js